// src/app/app.component.ts
import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatToolbarModule } from "@angular/material/toolbar";
import { Router, RouterLink, RouterOutlet } from "@angular/router";
import { AuthService } from "./service/auth.service";
import { AppHeaderComponent } from "./app-header.component";
import { TopProgressBarComponent } from "./top-progressbar.component";
@Component({
  selector: "app-root",
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    RouterOutlet,
    MatToolbarModule,
    MatButtonModule,
    TopProgressBarComponent,
    AppHeaderComponent,
  ],
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  constructor(public authService: AuthService, private router: Router) {}

  logout() {
    this.authService.logout().subscribe({
      next: () => this.router.navigate(["/login"], { replaceUrl: true }),
      error: () => this.router.navigate(["/login"], { replaceUrl: true }),
    });
    this.router.navigate(["/login"]);
  }
}
